import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface RatingStarProps {
  isSelected?: boolean;
  isHover?: boolean;
  style?: React.CSSProperties;
}

export default function AnalyticsIcon({ isSelected = false, isHover = false, style = {}, ...props }: RatingStarProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 48 48" style={{ width: `24px`, height: `24px`, ...style }}>
      {isSelected ? (
        <g>
          <path
            fill={RoutalPalette.primary40}
            d="M28.78,1.16c-.18-.05-.36-.09-.56-.09h-8.44c-1.13,0-2.04,.91-2.04,2.04V44.89c0,.84,.51,1.57,1.24,1.88,.05,.02,.1,.03,.15,.05,.2,.07,.42,.12,.65,.12h8.44c1.13,0,2.04-.91,2.04-2.04V3.11c0-.93-.63-1.71-1.48-1.95Z"
          />
          <path
            fill={RoutalPalette.primary40}
            d="M46.33,17.82s-.02-.02-.03-.02c-.24-.23-.53-.39-.86-.49-.18-.05-.36-.09-.56-.09h-8.44c-1.13,0-2.04,.91-2.04,2.04v25.63c0,.84,.51,1.57,1.24,1.88,.05,.02,.1,.03,.15,.05,.2,.07,.42,.12,.65,.12h8.44c1.13,0,2.04-.91,2.04-2.04V19.26c0-.56-.23-1.07-.6-1.44Z"
          />
          <path
            fill={RoutalPalette.primary40}
            d="M12.34,26.4s-.1-.03-.15-.05c-.2-.07-.42-.12-.65-.12H3.11c-1.13,0-2.04,.91-2.04,2.04v16.61c0,.84,.51,1.57,1.24,1.88,.05,.02,.1,.03,.15,.05,.2,.07,.42,.12,.65,.12H11.55c1.13,0,2.04-.91,2.04-2.04V28.28c0-.84-.51-1.57-1.24-1.88Z"
          />
        </g>
      ) : isHover ? (
        <g>
          <path
            fill={RoutalPalette.primary20}
            d="M28.78,1.16c-.18-.05-.36-.09-.56-.09h-8.44c-1.13,0-2.04,.91-2.04,2.04V44.89c0,.84,.51,1.57,1.24,1.88,.05,.02,.1,.03,.15,.05,.2,.07,.42,.12,.65,.12h8.44c1.13,0,2.04-.91,2.04-2.04V3.11c0-.93-.63-1.71-1.48-1.95Z"
          />
          <path
            fill={RoutalPalette.primary20}
            d="M46.33,17.82s-.02-.02-.03-.02c-.24-.23-.53-.39-.86-.49-.18-.05-.36-.09-.56-.09h-8.44c-1.13,0-2.04,.91-2.04,2.04v25.63c0,.84,.51,1.57,1.24,1.88,.05,.02,.1,.03,.15,.05,.2,.07,.42,.12,.65,.12h8.44c1.13,0,2.04-.91,2.04-2.04V19.26c0-.56-.23-1.07-.6-1.44Z"
          />
          <path
            fill={RoutalPalette.primary20}
            d="M12.34,26.4s-.1-.03-.15-.05c-.2-.07-.42-.12-.65-.12H3.11c-1.13,0-2.04,.91-2.04,2.04v16.61c0,.84,.51,1.57,1.24,1.88,.05,.02,.1,.03,.15,.05,.2,.07,.42,.12,.65,.12H11.55c1.13,0,2.04-.91,2.04-2.04V28.28c0-.84-.51-1.57-1.24-1.88Z"
          />
        </g>
      ) : (
        <g>
          <path
            fill={RoutalPalette.neutral60}
            d="M26.26,5.07V42.93h-4.51V5.07h4.51m1.96-4h-8.44c-1.13,0-2.04,.91-2.04,2.04V44.89c0,1.13,.91,2.04,2.04,2.04h8.44c1.13,0,2.04-.91,2.04-2.04V3.11c0-1.13-.91-2.04-2.04-2.04h0Z"
          />
          <path
            fill={RoutalPalette.neutral60}
            d="M42.93,21.22v21.71h-4.51V21.22h4.51m1.96-4h-8.44c-1.13,0-2.04,.91-2.04,2.04v25.63c0,1.13,.91,2.04,2.04,2.04h8.44c1.13,0,2.04-.91,2.04-2.04V19.26c0-1.13-.91-2.04-2.04-2.04h0Z"
          />
          <path
            fill={RoutalPalette.neutral60}
            d="M9.58,30.24v12.69H5.07v-12.69h4.51m1.96-4H3.11c-1.13,0-2.04,.91-2.04,2.04v16.61c0,1.13,.91,2.04,2.04,2.04H11.55c1.13,0,2.04-.91,2.04-2.04V28.28c0-1.13-.91-2.04-2.04-2.04h0Z"
          />
        </g>
      )}
    </SvgIcon>
  );
}
